import { render } from "./AddBescStep1.vue?vue&type=template&id=574a0e7d&scoped=true&ts=true"
import script from "./AddBescStep1.vue?vue&type=script&lang=ts"
export * from "./AddBescStep1.vue?vue&type=script&lang=ts"

import "./AddBescStep1.vue?vue&type=style&index=0&id=574a0e7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574a0e7d"]])

export default __exports__